/* SkyVault Pro theme scripts — no dependencies */
(function () {
  'use strict';
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Mobile navigation ---------- */
  const menuToggle = $('[data-menu-toggle]');
  const nav = $('#SiteNav');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open);
    });
    $$('.site-nav__item.has-dropdown > .site-nav__link', nav).forEach((link) => {
      link.addEventListener('click', (e) => {
        if (window.matchMedia('(max-width: 900px)').matches) {
          const item = link.parentElement;
          if (!item.classList.contains('is-expanded')) {
            e.preventDefault();
            item.classList.add('is-expanded');
          }
        }
      });
    });
  }

  /* ---------- Hero slider ---------- */
  $$('[data-slider]').forEach((slider) => {
    const slides = $$('.hero-slide', slider);
    const dots = $$('[data-slide-to]', slider);
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const go = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    };
    const seconds = parseInt(slider.dataset.autoplay, 10) || 0;
    const start = () => { if (seconds > 0) timer = setInterval(() => go(index + 1), seconds * 1000); };
    const stop = () => clearInterval(timer);
    dots.forEach((dot) => dot.addEventListener('click', () => { stop(); go(+dot.dataset.slideTo); start(); }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- Toast & cart count ---------- */
  const toast = $('[data-toast]');
  let toastTimer;
  function showToast(html, isError) {
    if (!toast) return;
    toast.innerHTML = html;
    toast.classList.toggle('toast--error', !!isError);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4000);
  }
  function updateCartCount() {
    fetch(window.theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        $$('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const button = $('[type="submit"]', form);
    const originalText = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = '…'; }

    fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || data.message || 'Could not add to cart');
        showToast(`<span>✓ ${data.product_title || 'Item'} added to cart</span><a href="${window.theme.routes.cart}">View cart</a>`);
        updateCartCount();
      })
      .catch((err) => showToast(err.message, true))
      .finally(() => {
        if (button) { button.disabled = false; button.textContent = originalText; }
      });
  });

  /* ---------- Product page: gallery + variants ---------- */
  const productEl = $('[data-product]');
  if (productEl) {
    const mainImg = $('.js-main-image', productEl);
    const thumbs = $$('[data-thumb]', productEl);
    const setMain = (src, mediaId) => {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      thumbs.forEach((t) => t.classList.toggle('is-active', String(t.dataset.mediaId) === String(mediaId)));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => setMain(t.dataset.src, t.dataset.mediaId)));

    const jsonEl = $('[data-product-json]', productEl);
    const form = $('[data-product-form]', productEl);
    if (jsonEl && form) {
      const data = JSON.parse(jsonEl.textContent);
      const idInput = $('[data-variant-id]', form);
      const addBtn = $('[data-add-button]', form);
      const priceWrap = $('[data-price-wrapper]', productEl);
      const stockEl = $('[data-stock]', productEl);
      const skuEl = $('[data-sku]', productEl);
      const groups = $$('.option-group', form);

      const selected = () => groups.map((g) => {
        const checked = $('input:checked', g);
        return checked ? checked.value : null;
      });

      const markAvailability = () => {
        const current = selected();
        groups.forEach((g, gi) => {
          $$('.option-pill', g).forEach((pill) => {
            const val = $('input', pill).value;
            const test = current.slice();
            test[gi] = val;
            const ok = data.variants.some((v) => v.available && v.options.every((o, i) => o === test[i]));
            pill.classList.toggle('is-unavailable', !ok);
          });
        });
      };

      const render = () => {
        const opts = selected();
        groups.forEach((g, i) => { const l = $('[data-option-label]', g); if (l) l.textContent = opts[i]; });
        const variant = data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
        markAvailability();

        if (!variant) {
          addBtn.disabled = true;
          addBtn.textContent = data.strings.unavailable;
          return;
        }
        idInput.value = variant.id;
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? data.strings.addToCart : data.strings.soldOut;

        if (priceWrap) {
          let html = `<div class="price price--large${variant.compare ? ' price--sale' : ''}"><span class="price__current">${variant.price}</span>`;
          if (variant.compare) html += `<s class="price__compare">${variant.compare}</s><span class="price__savings">You save ${variant.savings}</span>`;
          priceWrap.innerHTML = html + '</div>';
        }
        if (stockEl) {
          stockEl.innerHTML = variant.available
            ? `<span class="stock stock--in">✓ ${data.strings.inStock}</span>`
            : `<span class="stock stock--out">${data.strings.soldOut}</span>`;
        }
        if (skuEl && variant.sku) skuEl.textContent = variant.sku;
        if (variant.image) setMain(variant.image, variant.mediaId);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      };

      groups.forEach((g) => g.addEventListener('change', render));
      if (groups.length) markAvailability();
    }
  }

  /* ---------- Product tabs ---------- */
  $$('[data-tabs]').forEach((wrap) => {
    const buttons = $$('[data-tab]', wrap);
    buttons.forEach((btn) => btn.addEventListener('click', () => {
      buttons.forEach((b) => b.classList.toggle('is-active', b === btn));
      $$('[data-panel]', wrap).forEach((p) => p.classList.toggle('is-active', p.dataset.panel === btn.dataset.tab));
    }));
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach((el) => {
    fetch(el.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  });

  /* ---------- Collection: filters, sort, view, drawer ---------- */
  const facetsForm = $('[data-facets-form]');
  if (facetsForm) {
    facetsForm.addEventListener('change', (e) => {
      if (e.target.matches('[data-autosubmit]')) facetsForm.requestSubmit ? facetsForm.requestSubmit() : facetsForm.submit();
    });
    // Drop empty fields so URLs stay clean
    facetsForm.addEventListener('submit', () => {
      $$('input', facetsForm).forEach((i) => { if (i.type !== 'checkbox' && i.value === '') i.disabled = true; });
    });
  }

  const sortSelect = $('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  const grid = $('[data-product-grid]');
  const viewButtons = $$('[data-view]');
  if (grid && viewButtons.length) {
    const setView = (view) => {
      grid.classList.remove('product-grid--grid', 'product-grid--list');
      grid.classList.add('product-grid--' + view);
      viewButtons.forEach((b) => b.classList.toggle('is-active', b.dataset.view === view));
      try { localStorage.setItem('skyvault-view', view); } catch (err) { /* storage unavailable */ }
    };
    let saved = null;
    try { saved = localStorage.getItem('skyvault-view'); } catch (err) { /* ignore */ }
    if (saved) setView(saved);
    viewButtons.forEach((b) => b.addEventListener('click', () => setView(b.dataset.view)));
  }

  const drawer = $('#FacetsDrawer');
  $$('[data-facets-open]').forEach((b) => b.addEventListener('click', () => drawer && drawer.classList.add('is-open')));
  $$('[data-facets-close]').forEach((b) => b.addEventListener('click', () => drawer && drawer.classList.remove('is-open')));

  /* ---------- Accounts ---------- */
  $$('[data-toggle-recover]').forEach((link) => link.addEventListener('click', (e) => {
    e.preventDefault();
    const box = $('#recover');
    if (box) box.classList.toggle('is-open');
  }));
  $$('select[data-default]').forEach((sel) => { if (sel.dataset.default) sel.value = sel.dataset.default; });
})();
